import ajax from '../../lib/ajax'
export async function QueryStockList(payload:any) {
    let res = await ajax.post('api/services/app/Stock/QueryStockList',payload,false)
    return res.data.result
}
export async function QueryStockWarning(payload:any) {
    let res = await ajax.post('api/services/app/Stock/QueryStockWarning',payload,false)
    return res.data.result
}
export async function DelStockDetail(payload:any) {
    let res = await ajax.post('api/services/app/Stock/QueryStockList',payload)
    return res.data.result
}
export async function QueryStockActionList(payload:any) {
    let res = await ajax.post('api/services/app/Stock/QueryStockActionList',payload,false)
    return res.data.result
}
export async function EditStockActionDetail(payload:any) {
    let res = await ajax.post('api/services/app/Stock/EditStockActionDetail',payload)
    return res.data.result
}
export async function CheckStockAction(payload:any) {
    let res = await ajax.post('api/services/app/Stock/CheckStockAction?ActionId='+payload.actionId,payload)
    return res.data.result
}
export async function BillingStockAction(payload:any) {
    let res = await ajax.post('api/services/app/Stock/BillingStockAction?ActionId='+payload.actionId,payload)
    return res.data.result
}
export async function QueryStockBatchList(payload:any) {
    let res = await ajax.post('api/services/app/Stock/QueryStockBatchList',payload,false)
    return res.data.result
}


export async function GetQueryStockActionDetailList(payload:any) {
    let res = await ajax.get('api/services/app/Stock/GetQueryStockActionDetailList',{params:payload},false)
    return res.data.result
}